import { Container } from '@mui/material';
import React from 'react';
import LoadingErrorPageBody from './ErrorPageBody/LoadingErrorPageBody';
import NotFoundErrorPageBody from './ErrorPageBody/NotFoundErrorPageBody';
import UnknownErrorPageBody from './ErrorPageBody/UnknowErrorPageBody';

interface ErrorPageProps {
  errorType?: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ errorType }) => {
  const content = (() => {
    switch (errorType) {
      case '404':
        return <NotFoundErrorPageBody />;
      case 'loading-error':
        return <LoadingErrorPageBody />;
      default:
        return <UnknownErrorPageBody />;
    }
  })();

  return <Container maxWidth="xl">{content}</Container>;
};

export default ErrorPage;
